// versionDecision — what an open tab does when the live build is not the one it is running.
// T506 (2026-10-06), v0.1. Pure, so scripts/test-version-check.mjs can prove it.
//
//   same commit (or either unknown)        -> "none"
//   newer build, page idle, not yet tried  -> "reload"   (once per commit per tab)
//   newer build, unsaved input or a send   -> "bar"      ("A newer version of MentionFox is ready.")
//   newer build, already reloaded for it   -> "bar"      (never a loop)

export type VersionAction = "none" | "reload" | "bar";

export interface VersionInput {
  /** The commit this bundle was built from. */
  mine: string | null | undefined;
  /** The commit /build-info.json says is live. */
  live: string | null | undefined;
  /** Some field on the page has input that was typed and may not be saved. */
  dirty: boolean;
  /** A save or send request is still in flight. */
  busy: boolean;
  /** The live commit this tab already reloaded itself for, if any. */
  reloadedFor: string | null | undefined;
}

export function decideVersionAction(i: VersionInput): VersionAction {
  const mine = String(i.mine || "").trim();
  const live = String(i.live || "").trim();
  if (!mine || !live || mine === live) return "none";
  if (i.reloadedFor && i.reloadedFor === live) return "bar";
  if (i.dirty || i.busy) return "bar";
  return "reload";
}
